module.exports = __webpack_public_path__ + "img/CM-KT-25-Cadillac-Modern.5f495eaa.jpg";